export default __webpack_public_path__ + "static/media/female-slim.5cefa420.jpg";